import { COUNTRIES } from "@wayflyer/flyui";

import type { PhoneNumber } from "../api-types/jurisdictions/us_schemas";

export const formatSelectedOptionForDisplay = (options, selectedOption) => {
  return options?.find((option) => option.id === selectedOption)?.text;
};

export const formatPhoneNumberForDisplay = (phoneNumber?: PhoneNumber) => {
  if (phoneNumber) {
    const prefix = COUNTRIES.find((country) => country.code === phoneNumber.regionCode)?.prefix;
    return `${prefix} ${phoneNumber.number}`;
  } else {
    return null;
  }
};
